import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PortLanIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_308"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_308)">
        <path
          d="M1.9 1.5C1.67909 1.5 1.5 1.67909 1.5 1.9V14.1C1.5 14.3209 1.67909 14.5 1.9 14.5H14.1C14.3209 14.5 14.5 14.3209 14.5 14.1V1.9C14.5 1.67909 14.3209 1.5 14.1 1.5H1.9ZM2.68182 3.08182C2.68182 2.8609 2.8609 2.68182 3.08182 2.68182H12.9182C13.1391 2.68182 13.3182 2.8609 13.3182 3.08182V12.9182C13.3182 13.1391 13.1391 13.3182 12.9182 13.3182H3.08182C2.8609 13.3182 2.68182 13.1391 2.68182 12.9182V3.08182ZM7.21818 5.04545C6.99727 5.04545 6.81818 5.22454 6.81818 5.44545V6.41818C6.81818 6.6391 6.6391 6.81818 6.41818 6.81818H5.44545C5.22454 6.81818 5.04545 6.99727 5.04545 7.21818V10.5545C5.04545 10.7755 5.22454 10.9545 5.44545 10.9545H5.82727C6.04819 10.9545 6.22727 10.7755 6.22727 10.5545V10.1727C6.22727 9.95181 6.40636 9.77273 6.62727 9.77273H7.00909C7.23 9.77273 7.40909 9.95181 7.40909 10.1727V10.5545C7.40909 10.7755 7.58818 10.9545 7.80909 10.9545H8.19091C8.41182 10.9545 8.59091 10.7755 8.59091 10.5545V10.1727C8.59091 9.95181 8.76999 9.77273 8.99091 9.77273H9.37273C9.59364 9.77273 9.77273 9.95181 9.77273 10.1727V10.5545C9.77273 10.7755 9.95181 10.9545 10.1727 10.9545H10.5545C10.7755 10.9545 10.9545 10.7755 10.9545 10.5545V7.21818C10.9545 6.99727 10.7755 6.81818 10.5545 6.81818H9.58182C9.3609 6.81818 9.18182 6.6391 9.18182 6.41818V5.44545C9.18182 5.22454 9.00273 5.04545 8.78182 5.04545H7.21818Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortLanIcon.displayName = 'PortLanIcon';
